import { render } from "./ApplicationPage.vue?vue&type=template&id=ce2277ca&scoped=true"
import script from "./ApplicationPage.vue?vue&type=script&lang=js"
export * from "./ApplicationPage.vue?vue&type=script&lang=js"

import "./ApplicationPage.vue?vue&type=style&index=0&id=ce2277ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ce2277ca"

export default script